import React from 'react';
import { useQuery } from '@apollo/react-hooks';
import { ChangeTextFieldUser, ChangeSelectFieldUser } from './UserChangeFields';
import queryGetUserAdmin from '../../../../queries/getUserAdmin';
import _ from 'lodash';
import queryCurrentUser from '../../../../queries/user';
import { states, countries } from '../../../../config/supported_areas';
import DetailsTable from '../../../Table/DetailsTable';
import DetailsRow from '../../../Table/DetailsRow';
import moment from 'moment';

const W8Tab = (props) => {
  const { data } = useQuery(queryCurrentUser);
  const { user } = props;
  if (!user)
    return <div>No Information of this User</div>;

  const { id } = user;
  const adminLevel = _.get(data, 'user.adminLevel', 0);

  const refetch = [
    {
      query: queryGetUserAdmin,
      variables: { id: user.id },
    },
  ];

  const termsDate = _.get(user, 'w8.termsDate');

  return (
    <div style={{ margin: '10px' }}>
      <DetailsTable>

        <ChangeTextFieldUser
          label={'Name'}
          value={_.get(user, 'w8.name', null)}
          property={'w8.name'}
          refetch={refetch}
          id={id}
          table
        />

        <ChangeTextFieldUser
          label={'Permanent Residence Address'}
          value={_.get(user, 'w8.PermanentResidenceAddress', null)}
          property={'w8.PermanentResidenceAddress'}
          refetch={refetch}
          id={id}
          table
        />

        <ChangeTextFieldUser
          label={'City/Town'}
          value={_.get(user, 'w8.city', null)}
          property={'w8.city'}
          refetch={refetch}
          id={id}
          table
        />

        <ChangeTextFieldUser
          label={'US TaxPayer ID'}
          value={_.get(user, 'w8.USTaxPayerID', null)}
          property={'w8.USTaxPayerID'}
          refetch={refetch}
          id={id}
          table
        />

        <ChangeSelectFieldUser
          label={'Foreign Tax ID'}
          value={_.get(user, 'w8.ForeignTaxID', null)}
          property={'w8.ForeignTaxID'}
          refetch={refetch}
          id={id}
          table
        />

        <ChangeTextFieldUser
          label={'FTIN Required'}
          value={_.get(user, 'w8.FTINRequired', null)}
          property={'w8.FTINRequired'}
          refetch={refetch}
          id={id}
          table
        />

        <ChangeSelectFieldUser
          label={'ReferenceNumber'}
          value={_.get(user, 'w8.ReferenceNumber', null)}
          property={'w8.ReferenceNumber'}
          refetch={refetch}
          id={id}
          table
        />

       
        <DetailsRow
          property='Accepted Terms'
          value={_.get(user, 'w8.acceptedTerms', 'N/A') ? 'Yes' : 'No'}
        />

        <DetailsRow
          property='Terms Date'
          value={termsDate ? moment(termsDate).format('YYYY-MM-DD') : 'N/A'}
        />
      </DetailsTable>
    </div>
  );
};

export default W8Tab;

const IDTypeOptions = [
  { label: 'Social Security Number (SSN)', value: 'ssn' },
  { label: 'Employer Identification Number (EIN)', value: 'ein' },
];

export const TaxClassificationOptions = [
  {
    label: 'Individual/sole proprietor or single-member LLC',
    value: 'individual',
  },
  { label: 'Limited liability company', value: 'llc' },
  { label: 'C Corporation', value: 'c_corporation' },
  { label: 'S Corporation', value: 's_corporation' },
  { label: 'Partnership', value: 'partnership' },
  { label: 'Trust/estate', value: 'trust_estate' },
];
